import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar from "../components/Sidebar";

const RootLayout: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
      }}
    >
      <Sidebar />
      <Box
        sx={{
          flexGrow: 1,
          marginLeft: "280px",
          height: "100%",
          width: "100%",
          background: "white",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default RootLayout;
